import React, { useState } from 'react';
import CryptoJS from 'crypto-js';
import sha256 from 'crypto-js/sha256';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ApiHelper from 'utils/apiHelper';
import { validateEmail, validatePassword } from 'utils/commonHelpers';

const RegisterDialog = ({ onClose }) => {
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState('');

    const handleSelectedFile = (e) => {
        if (e.target.files[0].name.split('.')[1] !== 'xml') {
            toast.warning('The organization key file should be xml file');
            return true;
        }
        setSelectedFile(e.target.files[0]);
        setSelectedFileName(e.target.files[0].name);
    };

    const handleSubmit = () => {
        if (username === '') {
            toast.warning('Username is required');
            return true;
        } else {
            if (email === '') {
                toast.warning('Email is required');
                return true;
            }
            if (!validateEmail(email)) {
                toast.warning('Invalid email format');
                return true;
            }
        }
        if (password === '') {
            toast.warning('Password is required');
            return true;
        }
        if (!validatePassword(password)) {
            toast.warning('Password should be at least 8 characters, and should contain capital & lower letter and number');
            return true;
        }
        if (password !== confirmPassword) {
            toast.warning('Confirm password does not match');
            return true;
        }
        setLoading(true);

        let formData = new FormData();
        formData.append('username', username);
        formData.append('email', email);
        formData.append('password', sha256(password).toString(CryptoJS.enc.Hex));
        formData.append('file', selectedFile);

        ApiHelper.post(
            '/api/auth/register/',
            formData,
            {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            },
            false
        )
            .then(() => {
                toast.success('Successfully registered, please check your email to validate your account');
                setLoading(false);
                onClose();
            })
            .catch((err) => {
                if (err.response.data.message !== '') {
                    toast.error(`Failed! ${err.response.data.message}`);
                } else {
                    toast.error('Failed to register');
                }
                setLoading(false);
            });
    };

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Please Register Now!</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 2, mt: 2 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 2, mt: 2 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 2, mt: 2 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        type="password"
                        label="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 2, mt: 2 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        type="password"
                        label="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 1, mt: 2, display: 'flex' }}>
                    <Button variant="contained" component="label">
                        Upload Organization Key File
                        <input type="file" accept=".xml,.txt" hidden onChange={handleSelectedFile} />
                    </Button>
                    <Typography sx={{ mt: 1, marginLeft: '20px' }}>{selectedFileName}</Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <LoadingButton onClick={handleSubmit} loading={loading} color="primary" variant="contained">
                    <span>Submit</span>
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

RegisterDialog.propTypes = {
    onClose: PropTypes.func
};

export default RegisterDialog;
